<template>
  <QueryView
    ref="queryView"
    :table-config="tableConfig"
    :town-selection="true"
    :region-selection="false"
    :province-selection="false"
    use-expansion
  >
    <template #expansion="{data}">
      <div
        v-if="!!data?.photoUrl"
        class="query-photos-view__photo--big"
      >
        <img
          :src="data.photoUrl"
          @click="goPhoto(data)"
        />
      </div>
    </template>
    <template #field__photoUrl="{data}">
      <div
        v-if="!!data?.photoUrl"
        class="query-photos-view__photo--mini"
      >
        <img
          :src="data.photoUrl"
          @click="goPhoto(data)"
        />
      </div>
    </template>
  </QueryView>
</template>

<script setup>
import {ref} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryTableConfig from '../query-table.view-config.js';
import {PHOTOS_SCHEMA} from './query-photos-table.view-config';
import {searchPhoto} from '@/api/photo/photo.api';
import {searchPhotosPdf, getPhotoPdf} from '@/api/photo/photo.api.pdf.js';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const queryView = ref();
const {copy} = useClipboard();
// #endregion

// #region Functions
async function printPhoto(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(data.id, 'Foto - ' + data.name, getPhotoPdf);
  }
}
async function printPhotoQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe foto', searchPhotosPdf);
  }
}
async function goPhoto({
  coordinates,
  name,
  visible,
}) {
  const zoom = 10;
  const goCoordinates = queryView?.value?.goCoordinates;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}

function photoToText({name, town, file, photoUrl}) {
  const res = `
    Nombre: ${name}
    Población: ${town}
    Fichero: ${file}
    URL: ${photoUrl}
    `;
  return res;
}
// #endregion
// functions previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchPhoto,
  recordToText: photoToText,
  copyClipboard: copy,
  printQuery: printPhotoQuery,
  printRecord: printPhoto,
  centerMap: goPhoto,
  schema: PHOTOS_SCHEMA,
});
//

// #region Effects, Hooks
// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
.query-photos-view {
  &__photo {
    margin: 1rem auto;
    &--big {
      width: 95%;
      & img {
        cursor: pointer;
        display: block;
        margin: 1rem auto;
        max-width: 100%;
      }
    }
    &--mini {
      & img {
        cursor: pointer;
        max-width: 70px;
        max-height: 70px;
      }
    }
  }
}
</style>
